import { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";

interface GuideSectionProps {
  id: string;
  title: string;
  description: string;
  children: ReactNode;
}

export function GuideSection({ id, title, description, children }: GuideSectionProps) {
  return (
    <section id={id} className="scroll-mt-24">
      <div className="mb-8">
        <h2 className="text-3xl font-bold tracking-tight mb-2">{title}</h2>
        <p className="text-lg text-muted-foreground">{description}</p>
      </div>
      
      {children}
      
      <Separator className="my-12" />
    </section>
  );
}
